import {useRef} from 'react';

import {extractRunFilterErrorMessage} from './errors';

export function useLatchedInvalidRunFilter(
  error: unknown,
  filterKey: string
): boolean {
  const keyRef = useRef<string | null>(null);
  const latchRef = useRef(false);
  if (keyRef.current !== filterKey) {
    keyRef.current = filterKey;
    latchRef.current = false;
  }
  if (extractRunFilterErrorMessage(error) != null) {
    latchRef.current = true;
  }
  return latchRef.current;
}
